import CameraIcon from "../../assets/icons/CameraIcon";
import useLivePicture from "../../customHooks/useLivePicture";
import styles from "./styles.module.css";
import BtnSpinner from "../../assets/icons/BtnSpinner";
import CheckMarkIcon from "../../assets/icons/CheckMarkIcon";

interface LivePictureProps {
  onClickValidate: (file: File) => void;
  onClickOkay: () => void;
  isValidating: boolean;
  isValidated: boolean;
  matchScore: number;
  btnText: string;
}

const LivePicture: React.FC<Partial<LivePictureProps>> = ({
  onClickValidate,
  onClickOkay,
  isValidated,
  isValidating,
  matchScore,
  btnText,
}) => {
  const {
    imageSrc,
    canvasRef,
    capturePhoto,
    restartCamera,
    videoRef,
    imageFile,
  } = useLivePicture();
  return (
    <div className={styles.livePicWrapper}>
      {!imageSrc ? (
        <>
          <video
            key={imageSrc}
            ref={videoRef}
            autoPlay
            playsInline
            className={styles.liveVideo}
            disablePictureInPicture
          />
          <button onClick={capturePhoto} className={styles.cameraBtn}>
            <CameraIcon />
          </button>
        </>
      ) : (
        <>
          <img
            src={imageSrc}
            alt="Captured"
            className={styles.liveVideo}
            key={imageSrc}
          />
          <div className={styles.ctrlBtns}>
            {isValidated ? (
              <>
                <div className={styles.validationMsgWrapper}>
                  <div className={styles.greenCheckCircle}>
                    <CheckMarkIcon />
                  </div>
                  <div className={styles.validationMsgRight}>
                    <span className="">Validated</span>
                    <span className={styles.validationMsgDesc}>
                      Match score grade <strong>{matchScore}%</strong>
                    </span>
                  </div>
                </div>
                <button className={styles.retryBtn} onClick={onClickOkay}>
                  Okay
                </button>
              </>
            ) : (
              <>
                <button className={styles.retryBtn} onClick={restartCamera}>
                  Retry
                </button>
                <button
                  type="button"
                  className={styles.validateBtn}
                  onClick={() => onClickValidate(imageFile)}
                >
                  {isValidating && <BtnSpinner />} {btnText || "Validat"}
                  {isValidating ? "ing" : "e"}
                </button>
              </>
            )}
          </div>
        </>
      )}

      <canvas
        ref={canvasRef}
        width="400"
        height="300"
        style={{ display: "none" }}
      />
    </div>
  );
};

export default LivePicture;
